<template>
  <div>
    <SkeletonScreen v-if="!isCloseSkeletonScreen" :data="3" />
    <div v-if="isCloseSkeletonScreen">
      <div v-if="msg_list.length">
        <app-live-list-pub
          v-for="(item,index) in msg_list"
          :key="index"
          :live="item.live"
          :msg="item.msg"
          :is_vip="is_vip"
        ></app-live-list-pub>
      </div>
      <no-result v-if="!msg_list.length" title="此用户没有发布内容"></no-result>
      <loading
        class="loadbox"
        style="padding: 12px 0;"
        loadType="small"
        :title="'正在加载中...'"
        v-if="msg_list.length&&listLoading"
      ></loading>
      <no-data msg="已经到底了~" v-if="!listLoading&&hasMore&&msg_list.length"></no-data>
    </div>
  </div>
</template>
<script>
import UserProfilesApi from "@/api/userProfiles/";
import appLiveListPub from "@/components/appLiveListPub/";
import noData from "@/base/nodata/";
import noResult from "@/base/no-result/";

export default {
  name: "UserProfiles",
  components: {
    appLiveListPub,
    noData,
    noResult
  },
  computed: {
    userInfo() {
      return this.$store.state.userProfiles.userInfo;
    },
    view_user_id: {
      type: [String, Number],
      default: ""
    }
  },
  props: {
    pageType: {
      type: String,
      default: "teacher"
    }
  },
  data() {
    return {
      user_id: parseInt(this.$route.params.id),
      login_user_id: '',
      msg_list: [],
      isCloseSkeletonScreen: false,

      listLoading: true,
      hasMore: false,
      before: 0,
      is_vip: ""
    };
  },
  created() {
    //获取用户全部数据
    // this.init();
  },
  watch: {
    '$store.state.user': {
        immediate: true,
        deep: true,
        handler(val, oldVal) {
          if(val.userId && val.user_app_token && !this.login_user_id) {
            // 初始化
            this.login_user_id = val.userId;
          }
          setTimeout(() => {
            this.init();
          }, 200);
          
        }
      }
  },
  methods: {
    init() {
      console.log('????----')
      //获取用户全部数据
      if (this.pageType === "teacher") {
        this.getCenterList();
        //如果是用户则请求用户的tag列表
      } else {
        // this.getUserCenterList();
      }
    },
    columnListMore() {
      if (this.msg_list.length === 0) return;
      if (this.msg_list.length && this.hasMore) return;
      this.hasMore = true;
      this.before = this.msg_list[this.msg_list.length - 1].msg.rec_time;
      this.init();
    },
    //获取老师个人主页全部直播列表
    async getCenterList() {

      let userId = this.$store && this.$store.state && this.$store.state.user && this.$store.state.user.userId;
      console.log(userId,'请求 userId');
      if(!userId) userId = 0;

      this.listLoading = true;

      let centerList = await UserProfilesApi.getAdvisorVipList(
        this.user_id,
        this.before,
        userId,
        this.view_user_id
      );
      // this.$share(centerList.share);
      if (centerList && centerList.length > 0) {
        if (this.before) {
          this.msg_list = this.msg_list.concat(centerList);
        } else {
          this.msg_list = centerList;
        }
        this.is_vip = centerList[0].msg.is_vip;
        this.isData(centerList);
      } else {
        this.hasMore = true;
      }
      this.listLoading = false;
      this.isCloseSkeletonScreen = true;
      // this.$emit("scrollRefresh");
    },
    isData(data) {
      if (!data.length) {
        this.hasMore = true;
      } else {
        this.hasMore = false;
      }
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@color-red: #fe484a; //主色
@color-red-high: #c7000a; //特殊情况
@color-green: #0ac890; //主色
@color-blue: #1d88d0; //全文、超链接颜色
@color-gray-small: #f7f7f7; //转发内容背影色

@color-gray-high: #222222;
@color-gray-middle: #636363;
@color-gray-low: #939393;

.border-1px(@color: #ccc, @radius: 0px, @style: solid) {
  position: relative;

  &::after {
    content: "";
    pointer-events: none;
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    transform-origin: 0 0;
    border-bottom: 1px @style @color;
    border-radius: @radius;
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    @media (min-resolution: 2dppx) {
      width: 200%;
      height: 200%;
      border-radius: @radius * 2;
      transform: scale(0.5);
    }

    @media (min-resolution: 3dppx) {
      width: 300%;
      height: 300%;
      border-radius: @radius * 3;
      transform: scale(0.333);
    }
  }
}

.recommend {
  position: fixed;
  overflow: auto;
  top: 48px;
  width: 100%;
  padding-bottom: 50px;
  bottom: 0;
  background-color: #f0f0f0;
}

.recommend-content {
  height: 100%;
  overflow: hidden;
}
</style>